import React, { useEffect, useState } from 'react';
import { Modal } from '../../modal';
import { PhoneCallModal } from '../../modal/phone-call-modal';
import { END_OF_DAY_SCREEN } from '../../../constants/routes';
import { AudioManager } from '../../../controllers/audioController';

const PhoneCallModalParent = props => {
    const {
        currentCall,
        goToScreen,
        exitCall,
        removePhoneCall,
        audioIsOn,
    } = props;

    const [callExited, setCallExited] = useState(false);
    const [isMuted, setIsMuted] = useState(false);

    useEffect(() => {
        setIsMuted(AudioManager.isMuted());
        return () => {
            AudioManager.unMute();
        };
    }, []);

    return (
        <Modal
            onClick={() => {
                if (currentCall && currentCall.taskType === 'fail') {
                    exitCall(END_OF_DAY_SCREEN);
                }
                setCallExited(true);
            }}
            ariaLabel="phone call"
            modalFooterHidden
            translation
            muteButton={audioIsOn}
            isMuted={isMuted}
            onMute={() => {
                setIsMuted(!isMuted);
                AudioManager.toggleMute();
            }}
        >
            <PhoneCallModal
                currentCall={currentCall}
                goToScreen={goToScreen}
                removePhoneCall={removePhoneCall}
                callExited={callExited}
                audioIsOn={audioIsOn}
            />
        </Modal>
    );
};

export { PhoneCallModalParent };
